export enum AcEnumDDFieldType {
    autoNumber = "auto_number",
    blob = "blob",
    date = "date",
    datetime = "datetime",
    double = "double",
    encrypted = "encrypted",
    guid = "guid",
    integer = "integer",
    json = "json",
    mediaJson = "media_json",
    password = "password",
    string = "string",
    text = "text",
    time = "time",
    timestamp = "timestamp",
    userDefinedFunction = "user_defined_function"
}